const Separator = ({ children, color = '' }) => (
  <div className={`c-separator ${color ? 'c-separator--brown' : ''}`}>
    <span className="c-separator__content">{children}</span>
    <span className="c-separator__separator" />
  </div>
);

export default Separator;
